function setupZendesk()
{
  if (window.zE)
  {
    zE('webWidget', 'setLocale', '');
    window.zESettings = {
      webWidget: {
        chat: {
          offlineForm: {
            greeting: {
              fr: "Sorry, we aren&#39;t online at the moment. Leave a message and we&#39;ll get back to you soon.",
              en: "Sorry, we aren&#39;t online at the moment. Leave a message and we&#39;ll get back to you soon.",
              de: "Sorry, we aren&#39;t online at the moment. Leave a message and we&#39;ll get back to you soon.",
              es: "Sorry, we aren&#39;t online at the moment. Leave a message and we&#39;ll get back to you soon.",
              nl: "Sorry, we aren&#39;t online at the moment. Leave a message and we&#39;ll get back to you soon.",
              ja: "Sorry, we aren&#39;t online at the moment. Leave a message and we&#39;ll get back to you soon.",
            }
          },
          prechatForm: {
              greeting: {
                    fr: htmlDecode("Hello and welcome to RobotShop. Please provide us with your email so we can better assist you and tell us how can we help you today?"),
                    en: "Hello and welcome to RobotShop. Please provide us with your email so we can better assist you and tell us how can we help you today?",
                    de: "Hello and welcome to RobotShop. Please provide us with your email so we can better assist you and tell us how can we help you today?",
                    es: "Hello and welcome to RobotShop. Please provide us with your email so we can better assist you and tell us how can we help you today?",
                    nl: "Hello and welcome to RobotShop. Please provide us with your email so we can better assist you and tell us how can we help you today?",
                    ja: "Hello and welcome to RobotShop. Please provide us with your email so we can better assist you and tell us how can we help you today?",
              },
            }
        }
      }
    };
  }
  else
  {
      setTimeout(setupZendesk, 100);
  }
}

function htmlDecode(value) 
{
  return $("<textarea/>").html(value).text();
} 

setupZendesk();